import axios from "axios";
import { GetStorage } from "../Utils/Storage";
import { ReduxStore } from "..";
import { Notification } from "../Utils/Notification";

export function api() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
        "X-Language": "EN",
    },
  });

  api.interceptors.request.use(
    function (config) {
      const token = GetStorage("check_user_tenant_token") || GetStorage("optime_token");
      config.headers.Authorization = `Bearer ${token}` || "";
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // if (error?.response?.status === 401) {
    //   const { dispatch } = ReduxStore
    //   dispatch({ type: "USER_MUST_LOGIN", state: true })
    // }
    if (error?.response?.status === 403) {
      Notification.pushNotif("Access Denied", "error")
    }
    //catches if the session ended!
    return Promise.reject(error);
  });

  return api;
};

export function RouteApi() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_ROUTE_URL,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
        "X-Language": "EN",
    },
  });

  api.interceptors.request.use(
    function (config) {
      const token = GetStorage("check_user_tenant_token") || GetStorage("optime_token");
      config.headers.Authorization = `Bearer ${token}` || "";
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error?.response?.status === 401) {
      const { dispatch } = ReduxStore
      dispatch({ type: "USER_MUST_LOGIN", state: true })
    }
    if (error?.response?.status === 403) {
      Notification.pushNotif("Access Denied", "error")
    }
    //catches if the session ended!
    return Promise.reject(error);
  });

  return api;
};

export function analyticsApi() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_ANALYTICS_API_BASE_URL,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
        "X-Language": "EN",
    },
  });

  api.interceptors.request.use(
    function (config) {
      const token = GetStorage("check_user_tenant_token") || GetStorage("optime_token");
      config.headers["x-access-token"] = token || "";
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error?.response?.status === 401) {
      const { dispatch } = ReduxStore
      dispatch({ type: "USER_MUST_LOGIN", state: true })
    }
    if (error?.response?.status === 403) {
      Notification.pushNotif("Access Denied", "error")
    }
    //catches if the session ended!
    return Promise.reject(error);
  });

  return api;
};


// search engine instance
export function SearchApi() {
  const SearchApi = axios.create({
    baseURL: process.env.REACT_APP_SEARCH_ADDRESS_API_BASE_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
        "X-Language": "EN",
    },
  })

  let SearchEngineInstance = axios.create(SearchApi);

  SearchEngineInstance.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiNTNhNTJjZWItNThkZS00NjdiLThhYWEtOGVhMjk0ZjQyOWZlIiwiYXVkIjoiZmFzdGFwaS11c2VyczphdXRoIiwiZXhwIjoxNjUyMzcwMjQ2fQ.uO7zmjj0KM_-uS18gVHP9vM6wiphd_GNRUOl09pXxDk`;
    return config;
  });

  SearchApi.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error?.response?.status === 401) {
      const { dispatch } = ReduxStore
      dispatch({ type: "USER_MUST_LOGIN", state: true })
    }
    if (error?.response?.status === 403) {
      Notification.pushNotif("Access Denied", "error")
    }
    //catches if the session ended!
    return Promise.reject(error);
  });

  return SearchApi
};